
        // =======================================================================
        // Dialogs
        // =======================================================================
        function Dialog({ children, onClose, title, wide }) {
            return (
                <div className="dialog-backdrop" onClick={onClose}>
                    <div className="dialog" style={wide ? {maxWidth: '900px'} : {}} onClick={e => e.stopPropagation()}>
                        <div className="panel-header flex justify-between items-center">
                            <div className="font-display text-2xl gold">{title}</div>
                            <button className="text-muted hover:text-[var(--gold)] text-xl" onClick={onClose}>×</button>
                        </div>
                        <div className="p-6">{children}</div>
                    </div>
                </div>
            );
        }

export { Dialog };
